import { TransactionsFilterProperties } from './TransactionsFilterProperties';
import { TransactionsDateFilterState } from './TransactionsDateFilterState';
import { isInOptionalDateRange } from '../../../components/table/functions/isInOptionalDateRange';

export function filterTransactionByProperties(
  properties: TransactionsFilterProperties,
  state: TransactionsDateFilterState,
): boolean {
  if (typeof state.started === 'boolean') {
    if ((state.started && !properties.startedAt) || (!state.started && properties.startedAt)) {
      return false;
    }
  }

  if (state.startedDateRange) {
    if (!properties.startedAt || !isInOptionalDateRange(properties.startedAt, state.startedDateRange)) {
      return false;
    }
  }

  if (typeof state.approved === 'boolean') {
    if (state.approved !== properties.isApproved) {
      return false;
    }
  }

  if (state.approvedBy && state.approvedBy.name !== properties.approvedBy) {
    return false;
  }

  if (state.approvedDateRange) {
    if (!properties.approvedAt || !isInOptionalDateRange(properties.approvedAt, state.approvedDateRange)) {
      return false;
    }
  }

  return true;
}
